import { GetStaticPaths, GetStaticProps } from 'next'

import { getAllWhitepaperArticles, getWhitepaperArticleBySlug } from '@/graphql/WhitepaperArticle'

import { WhitepaperArticle } from '@/components/pages/whitepapers/WhitepaperArticle'

export const getStaticPaths: GetStaticPaths = async () => {
  const articles = await getAllWhitepaperArticles()
  const paths = (articles.allWhitepaperArticles || []).map((article) => `/whitepapers/${article.articleSlug}`)
  return { paths, fallback: false }
}

export const getStaticProps: GetStaticProps = async ({ params, preview }) => {
  const article = await getWhitepaperArticleBySlug(params?.slug, preview)

  if (article) {
    return { props: { article } }
  }

  throw new Error(`No slug found for whitepaper article: ${params?.slug}`)
}

export default WhitepaperArticle
